import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { Place, PlaceLevel } from "../../types/offers";

interface StateType {
  places: Record<string, Place>;
}

const initialState: StateType = {
  places: {},
};

const PlacesSlice = createSlice({
  name: "Places",
  initialState,
  reducers: {
    updatePlace: (state, action: PayloadAction<{ items: Place[] }>) => {
      for (const place of action.payload.items) {
        state.places[getPlaceUid(place.id, place.level)] = place;
      }
    },
  },
});

export const { updatePlace } = PlacesSlice.actions;

export const getPlaceUid = (id: number, level: PlaceLevel) => `${id}${level}`;

export default PlacesSlice.reducer;
